import React from 'react';

const WarningMessage = ({ message, type }) => (
    <div className={`alert alert-${type}`} role='alert'>
        {message}
    </div>
);

WarningMessage.defaultProps = {
    type: 'info',
};

export default WarningMessage;
